export const intervalInput = 'period'

export type Period =
  | 'last_week_period'
  | 'last_month_period'
  | 'last_6_month_period'
  | 'last_year_period'

export type ChartBucket = 'week' | 'month' | 'half_year' | 'year'

export const intervalValues: Period[] = [
  'last_week_period',
  'last_month_period',
  'last_6_month_period',
  'last_year_period']

export const defaultPeriod: Period = 'last_week_period'

export const matchValues: Record<Period, ChartBucket> = {
  last_week_period: 'week',
  last_month_period: 'month',
  last_6_month_period: 'half_year',
  last_year_period: 'year',
}
